module.exports = __webpack_public_path__ + "img/control_device4.e8b0bb4b.png";